export default __webpack_public_path__ + "static/media/menu-image4.473070ef.jpg";